import CommonFun from '../commontools/CommonFun.js'
import apiReq from '../commontools/api.js'
export function GetAllPermission(){
	var url='/Permission/GetAllPermission';
	return apiReq.get(url);
}
export function GetPermissionByRoleID(roleid){
	var url='/Permission/GetPermissionByRoleID/'+roleid;
	return apiReq.get(url);
}
export function AddPermission(info){
	var url='/Permission/AddPermission'
	var p={
		'data':info
	}
	return apiReq.post(url,p);
}
export function EditPermission(info){
	var url='/Permission/EditPermission';
	var p={
		'data':info
	}
	return apiReq.post(url,p);
}
export function DelPermission(permissionid){
	var url='/Permission/DelPermission/'+permissionid;
	return apiReq.get(url);
}
export default {
	GetAllPermission,
	GetPermissionByRoleID,
	AddPermission,
	EditPermission,
	DelPermission
}